'use strict';

/**
 * Simple Event Emitter base class.
 */
export default class EventEmitter {
  constructor() {
    this._handlers = {};
  }

  on(name, handler) {
    this._handlers[name] = this._handlers[name] || [];
    this._handlers[name].push(handler);
  }

  emit(name, data) {
    const _handlers = this._handlers[name];
    if(_handlers) {
      _handlers.forEach(handler => handler(data));
    }
  }

  off(name, cb) {
    const _handlers = this._handlers[name];
    if (_handlers) {
      let index;
      while ((index = _handlers.indexOf(cb)) > -1) {
        _handlers.splice(index, 1);
      }
    }
  }

  removeListeners(name) {
    if (name) {
      this._handlers[name] = {};
    } else {
      this._handlers = {};
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/event-emitter.js